import { ActionLink } from "@tandemdiabetes/sugarmate-react-components"
import { Link } from "@tanstack/react-router"

import styles from "./InviteAccepted.module.scss"
import { OnboardingPageTemplate } from "src/components"
import {
  usePolyglot,
  useFollowedUsers,
} from "src/contexts"
import { followToSharerFull } from "src/utils"

const prefix = "pages.onboarding.invitation_accepted"

interface Props {
  routePrefix: "/data_sharing/following" | "/onboarding";
}

export function InviteAccepted(props: Props) {
  const { routePrefix } = props

  const polyglot = usePolyglot()
  const {
    currentFollow,
    currentUserId,
  } = useFollowedUsers()

  const displayName = currentFollow ? followToSharerFull(currentFollow) : ""

  return (
    <OnboardingPageTemplate
      title={polyglot.t("components.page_header.pages.accept_invite")}
      hideUserName
    >
      <div
        className={styles.container}
        id="onboarding-invitation-accepted-screen"
      >
        <div className={styles.summaryTitle}>
          {polyglot.t(
            `${prefix}.title`,
            { user: displayName },
          )}
        </div>
        <div className={styles.summaryDescription}>
          {polyglot.t(
            `${prefix}.description_one`,
            { user: displayName },
          )}
        </div>
        <div className={styles.summaryDescription}>
          {polyglot.t(
            `${prefix}.description_two`,
            { user: displayName },
          )}
        </div>
        <ActionLink
          asChild
          className={styles.button}
        >
          <Link
            to={`${routePrefix}/accept_invite/$accountId/phone_call_alerts`}
            params={{ accountId: currentUserId ? `${currentUserId}` : "" }}
            id="skip-button"
          >
            {polyglot.t(`${prefix}.next_cta`)}
          </Link>
        </ActionLink>
      </div>
    </OnboardingPageTemplate>
  )
}
